<script setup lang="ts">
import AppHeader from "../components/AppHeader.vue";
import DashboardSidebar from "../components/dashboard/DashboardSidebar.vue";
import {
  dashboardNavigationItems,
  dashboardUserProfile,
} from "../features/dashboard/dashboardNav.ts";
import { useDashboardTheme } from "../features/dashboard/useDashboardTheme.ts";

const { theme, initializeDashboardTheme, setTheme } = useDashboardTheme();

initializeDashboardTheme();
</script>

<template>
  <div
    class="dashboard-shell flex h-screen flex-col overflow-hidden sm:flex-row"
  >
    <DashboardSidebar
      :items="dashboardNavigationItems"
      :theme="theme"
      :user="dashboardUserProfile"
      @set-theme="setTheme"
    />
    <!-- The header lives here, not in WorkflowLayout, so every page gets it by
         construction instead of by route nesting. -->
    <div class="dashboard-main flex min-h-0 min-w-0 flex-1 flex-col">
      <div class="shrink-0">
        <AppHeader />
      </div>
      <main class="flex min-h-0 flex-1 flex-col overflow-y-auto">
        <RouterView />
      </main>
    </div>
  </div>
</template>
